import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const MatchesActions = ({ dismissable, restorable, className, hasItemsSelected, onDismiss, onLink, onRestore }) => (
  <div className="matches-actions">
    <button
      className={classNames(className, 'c-btn c-btn--primary')}
      disabled={!hasItemsSelected}
      type="button"
      onClick={onLink}
    >
        Link
    </button>
    <button
      className={classNames(className, 'c-btn c-btn--primary')}
      display-if={dismissable}
      disabled={!hasItemsSelected}
      type="button"
      onClick={onDismiss}
    >
      Dismiss
    </button>
    <button
      className={classNames(className, 'c-btn c-btn--primary')}
      display-if={restorable}
      disabled={!hasItemsSelected}
      type="button"
      onClick={onRestore}
    >
      Restore
    </button>
  </div>
  );

MatchesActions.propTypes = {
  dismissable: PropTypes.bool,
  restorable: PropTypes.bool,
  className: PropTypes.string,
  hasItemsSelected: PropTypes.bool,
  onDismiss: PropTypes.func.isRequired,
  onLink: PropTypes.func.isRequired,
  onRestore: PropTypes.func.isRequired,
};

MatchesActions.defaultProps = {
  dismissable: false,
  restorable: false,
  className: undefined,
  hasItemsSelected: false,
};

export default MatchesActions;
